import React from 'react';

const EndChatModal = ({ isOpen, onClose, onEndChat }) => {
    if (!isOpen) return null;

    return (
        <div className="endchat-modal-overlay">
            <div className="endchat-modal-content">
                <h3 className="endchat-modal-title">End Chat</h3>
                <p className="endchat-modal-text">
                    You will lose your current chat context. Are you sure you want to exit?
                </p>
                <div className="endchat-modal-actions">
                    <button className="modal-btn modal-btn-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="modal-btn modal-btn-danger" onClick={onEndChat}>
                        End Chat
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EndChatModal;